/* eslint-disable no-console */
/*
 * EasyBarn — Custom Doors Calculator
 * ----------------------------------
 * Pricing engine + DOM wiring for the custom-doors-calculator section.
 * Source of truth for pricing: context/custom-doors/pricing-spec.xlsx
 *
 * Dimensions in millimetres.
 */

(function () {
  'use strict';

  // ------------------------------------------------------------
  // Pricing engine (ported from the spec's Pseudocode sheet)
  // ------------------------------------------------------------

  var STYLE_TO_RANGE = {
    Manhattan: 'standard',
    Liberty:   'standard',
    Newark:    'standard',
    Delaware:  'standard',
    Cottage:   'cottage',
    Hudson:    'hudson'
  };

  // Tier 2 is computed at runtime as Tier 1 × 1.4.
  var PRICE_MATRIX = {
    standard: { 1: 3999.00, 3: 5598.60,  4: 6998.25,  5: 8747.81,  6: 10934.77 },
    cottage:  { 1: 4299.00, 3: 6018.60,  4: 7523.25,  5: 9404.06,  6: 11755.08 },
    hudson:   { 1: 3999.00, 3: 5598.60,  4: 7278.18,  5: 9461.63,  6: 12300.12 }
  };

  var LIMITS = { hMin: 1, hMax: 2700, wMin: 1, wMax: 1800 };

  var TIER_DESCRIPTIONS = {
    1: 'Standard (2100 × 920)',
    2: 'Under-size (custom cut)',
    3: 'Tall (up to 2400H)',
    4: 'Extra-tall (up to 2700H)',
    5: 'Wide (up to 1800W)',
    6: 'Extra-large (2700 × 1800)'
  };

  function detectTier(h, w) {
    if (h < LIMITS.hMin || h > LIMITS.hMax) return null;
    if (w < LIMITS.wMin || w > LIMITS.wMax) return null;
    if (h === 2100 && w === 920)                                        return 1;
    if (h < 2100  && w <= 920)                                          return 2;
    if (h >= 2101 && h <= 2400 && w <= 920)                             return 3;
    if (h >= 2401 && h <= 2700 && w <= 920)                             return 4;
    if (h <= 2400 && w >= 921  && w <= 1800)                            return 5;
    if (h >= 2401 && h <= 2700 && w >= 921 && w <= 1800)                return 6;
    return null;
  }

  function selectHardware(w) {
    return w <= 920 ? 'STD 2.0m track' : 'SPEC 3.6m track';
  }

  function priceDoor(style, height, width) {
    var range = STYLE_TO_RANGE[style];
    if (!range) return { error: 'Unknown style: ' + style };
    var tier = detectTier(height, width);
    if (tier === null) return { error: 'OUT OF RANGE' };
    var matrix = PRICE_MATRIX[range];
    var price = tier === 2 ? matrix[1] * 1.4 : matrix[tier];
    return {
      style: style,
      range: range,
      tier: tier,
      height: height,
      width: width,
      price: price,
      hardware: selectHardware(width)
    };
  }

  // Expose for the README's "verify in DevTools" workflow.
  window.ebcdPriceDoor = priceDoor;

  // ------------------------------------------------------------
  // Self-tests (the 17 test cases from the spec sheet)
  // Run them by appending ?ebcd-debug=1 to the URL.
  // ------------------------------------------------------------

  function runSelfTests() {
    var cases = [
      { id: 1,  style: 'Manhattan', h: 2100, w: 920,  tier: 1, price: 3999,    hw: 'STD 2.0m track' },
      { id: 2,  style: 'Liberty',   h: 2000, w: 800,  tier: 2, price: 5598.6,  hw: 'STD 2.0m track' },
      { id: 3,  style: 'Newark',    h: 2400, w: 920,  tier: 3, price: 5598.6,  hw: 'STD 2.0m track' },
      { id: 4,  style: 'Delaware',  h: 2401, w: 920,  tier: 4, price: 6998.25, hw: 'STD 2.0m track' },
      { id: 5,  style: 'Manhattan', h: 2400, w: 1800, tier: 5, price: 8747.81, hw: 'SPEC 3.6m track' },
      { id: 6,  style: 'Manhattan', h: 2700, w: 1800, tier: 6, price: 10934.77,hw: 'SPEC 3.6m track' },
      { id: 7,  style: 'Cottage',   h: 2100, w: 920,  tier: 1, price: 4299,    hw: 'STD 2.0m track' },
      { id: 8,  style: 'Cottage',   h: 2050, w: 900,  tier: 2, price: 6018.6,  hw: 'STD 2.0m track' },
      { id: 9,  style: 'Cottage',   h: 2700, w: 1800, tier: 6, price: 11755.08,hw: 'SPEC 3.6m track' },
      { id: 10, style: 'Hudson',  h: 2100, w: 920,  tier: 1, price: 3999,    hw: 'STD 2.0m track' },
      { id: 11, style: 'Hudson',  h: 2050, w: 900,  tier: 2, price: 5598.6,  hw: 'STD 2.0m track' },
      { id: 12, style: 'Hudson',  h: 2700, w: 1800, tier: 6, price: 12300.12,hw: 'SPEC 3.6m track' },
      { id: 13, style: 'Manhattan', h: 2099, w: 920,  tier: 2, price: 5598.6,  hw: 'STD 2.0m track' },
      { id: 14, style: 'Manhattan', h: 2100, w: 921,  tier: 5, price: 8747.81, hw: 'SPEC 3.6m track' },
      { id: 15, style: 'Manhattan', h: 2800, w: 920,  error: true },
      { id: 16, style: 'Manhattan', h: 2100, w: 1801, error: true },
      { id: 17, style: 'Manhattan', h: 0,    w: 920,  error: true }
    ];
    var fails = 0;
    cases.forEach(function (t) {
      var r = priceDoor(t.style, t.h, t.w);
      var ok;
      if (t.error) {
        ok = !!r.error;
      } else {
        ok = r.tier === t.tier &&
             Math.abs(r.price - t.price) < 0.01 &&
             r.hardware === t.hw;
      }
      if (!ok) {
        fails += 1;
        console.error('[ebcd] test ' + t.id + ' FAILED', { expected: t, got: r });
      }
    });
    if (fails === 0) console.log('[ebcd] self-tests passed (' + cases.length + '/' + cases.length + ')');
    else             console.warn('[ebcd] self-tests: ' + (cases.length - fails) + '/' + cases.length + ' passed, ' + fails + ' failed');
  }

  // ------------------------------------------------------------
  // Formatting
  // ------------------------------------------------------------

  function formatCurrency(value, currency) {
    try {
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: currency || 'ZAR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return 'R ' + value.toFixed(2);
    }
  }

  // ------------------------------------------------------------
  // DOM wiring (one instance per .ebcd-root)
  // ------------------------------------------------------------

  function initRoot(root) {
    var configEl = root.querySelector('[data-ebcd-config]');
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[ebcd] config parse failed', e);
      return;
    }

    var heightEl = root.querySelector('[data-ebcd-height]');
    var widthEl  = root.querySelector('[data-ebcd-width]');
    var qtyEl    = root.querySelector('[data-ebcd-qty]');
    var styleEls = root.querySelectorAll('.ebcd-style-input');
    var resetEl  = root.querySelector('[data-ebcd-reset]');

    var outStyle    = root.querySelector('[data-ebcd-out-style]');
    var outSize     = root.querySelector('[data-ebcd-out-size]');
    var outTier     = root.querySelector('[data-ebcd-out-tier]');
    var outHardware = root.querySelector('[data-ebcd-out-hardware]');
    var outPrice    = root.querySelector('[data-ebcd-out-price]');
    var outPriceEx  = root.querySelector('[data-ebcd-out-price-excl]');
    var outQtyNote  = root.querySelector('[data-ebcd-out-qty-note]');
    var outOfRange  = root.querySelector('[data-ebcd-out-of-range]');
    var ctaAdd      = root.querySelector('[data-ebcd-cta-add]');
    var ctaError    = root.querySelector('[data-ebcd-cta-error]');
    var styleDescs  = root.querySelectorAll('[data-style-desc]');

    function selectedStyle() {
      for (var i = 0; i < styleEls.length; i += 1) {
        if (styleEls[i].checked) return styleEls[i].value;
      }
      return 'Manhattan';
    }

    function showStyleDesc(style) {
      styleDescs.forEach(function (d) {
        if (d.getAttribute('data-style-desc') === style) d.removeAttribute('hidden');
        else                                              d.setAttribute('hidden', '');
      });
    }

    function lookupVariantId(style, tier) {
      var map = config.variantMap || {};
      var styleMap = map[style];
      if (!styleMap) return null;
      var id = styleMap[String(tier)] || styleMap[tier];
      return id || null;
    }

    function update() {
      var style = selectedStyle();
      var h = parseInt(heightEl.value, 10);
      var w = parseInt(widthEl.value, 10);

      outStyle.textContent = style;
      showStyleDesc(style);

      if (isNaN(h) || isNaN(w)) {
        outSize.textContent = '—';
        outTier.textContent = '—';
        outHardware.textContent = '—';
        outPrice.textContent = '—';
        if (outPriceEx) outPriceEx.textContent = '';
        outOfRange.hidden = true;
        if (ctaAdd) ctaAdd.disabled = true;
        return;
      }

      outSize.textContent = h + ' × ' + w + ' mm';

      var r = priceDoor(style, h, w);
      if (r.error) {
        outTier.textContent = 'Out of range';
        outHardware.textContent = '—';
        outPrice.textContent = '—';
        if (outPriceEx) outPriceEx.textContent = '';
        outOfRange.hidden = false;
        if (ctaAdd) ctaAdd.disabled = true;
        return;
      }

      outOfRange.hidden = true;
      outTier.textContent = TIER_DESCRIPTIONS[r.tier] || 'Custom size';
      outHardware.textContent = r.hardware;

      var qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
      var lineTotal = r.price * qty;

      outPrice.textContent = formatCurrency(lineTotal, config.currency);
      if (outQtyNote) {
        if (qty > 1) {
          outQtyNote.textContent = formatCurrency(r.price, config.currency) + ' × ' + qty;
          outQtyNote.hidden = false;
        } else {
          outQtyNote.textContent = '';
          outQtyNote.hidden = true;
        }
      }

      if (ctaAdd) {
        var vid = lookupVariantId(style, r.tier);
        ctaAdd.disabled = !vid;
        ctaAdd.setAttribute('data-variant-id', vid || '');
        if (ctaError && !vid) {
          ctaError.textContent = 'Variant not configured for ' + style + ' / ' + (TIER_DESCRIPTIONS[r.tier] || 'this size') + '. Update the Variant ID map.';
          ctaError.hidden = false;
        } else if (ctaError) {
          ctaError.hidden = true;
        }
      }
    }

    function onAddToCart() {
      var style = selectedStyle();
      var h = parseInt(heightEl.value, 10);
      var w = parseInt(widthEl.value, 10);
      var qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
      var r = priceDoor(style, h, w);
      if (r.error) return;

      var vid = lookupVariantId(style, r.tier);
      if (!vid) return;

      var items = [{
        id: vid,
        quantity: qty,
        properties: {
          Style:  style,
          Height: h + ' mm',
          Width:  w + ' mm'
        }
      }];

      if (config.hardwareVariantId) {
        items.push({
          id: config.hardwareVariantId,
          quantity: qty,
          properties: {
            'Track size':   r.hardware,
            '_paired_with': 'Custom Barn Door — ' + style + ' (' + h + ' × ' + w + ' mm)'
          }
        });
      }

      var body = { items: items };

      ctaAdd.disabled = true;
      var originalLabel = ctaAdd.textContent;
      ctaAdd.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || res.statusText); });
        return res.json();
      }).then(function () {
        // Defer to the theme's own cart drawer / redirect — try a couple of common patterns.
        if (window.t4s && typeof window.t4s.cartDrawerOpen === 'function') {
          window.t4s.cartDrawerOpen();
        } else {
          window.location.href = '/cart';
        }
      }).catch(function (err) {
        if (ctaError) {
          ctaError.textContent = 'Could not add to cart: ' + err.message;
          ctaError.hidden = false;
        }
      }).finally(function () {
        ctaAdd.disabled = false;
        ctaAdd.textContent = originalLabel;
      });
    }

    function onReset() {
      if (styleEls.length) {
        for (var i = 0; i < styleEls.length; i += 1) styleEls[i].checked = (i === 0);
      }
      heightEl.value = 2100;
      widthEl.value  = 920;
      qtyEl.value    = 1;
      update();
      heightEl.focus();
    }

    heightEl.addEventListener('input', update);
    widthEl.addEventListener('input', update);
    qtyEl.addEventListener('input', update);
    styleEls.forEach(function (el) { el.addEventListener('change', update); });
    if (ctaAdd) ctaAdd.addEventListener('click', onAddToCart);
    if (resetEl) resetEl.addEventListener('click', onReset);

    update();
  }

  function init() {
    document.querySelectorAll('.ebcd-root').forEach(initRoot);

    if (/[?&]ebcd-debug=1\b/.test(window.location.search)) {
      runSelfTests();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
